import React from "react";
import { useParams } from "react-router-dom";
import { TitleSource } from "../teleporters/Title";

const OrgUsage = (props:any) => {
    let { orgId } = useParams();
    console.log('orgId', orgId);
    
    return (
        <div>
            <TitleSource><h4 className="m-0 mt-1">Organization -  Usage</h4></TitleSource>  
        </div>
    );
}

export default OrgUsage;